"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartAddTicket = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartAddTicket(clickElementText, clickText, clickUrl) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData: {
            feature_category: enums_1.GA4FeatureCategory.Cart,
            eventName: enums_1.GA4EventName.ClickTextLink,
            click_element: clickElementText,
            click_text: clickText,
            click_url: clickUrl,
        },
    });
}
exports.trackCartAddTicket = trackCartAddTicket;
//# sourceMappingURL=trackCartAddTicket.js.map